module.exports = __webpack_public_path__ + "img/DSC00448.9a61e3e7.JPG";